import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';

const Navbar = () => {
  const { user, logout } = useContext(AuthContext);
  const { language, setLanguage, t } = useLanguage();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-custom sticky-top">
      <div className="container">
        <Link className="navbar-brand d-flex align-items-center gap-2" to="/">
          <i className="bi bi-shield-check text-primary fs-3"></i>
          <span className="brand-font brand-gradient fs-4">{t('brandName')}</span>
        </Link>
        <button
          className="navbar-toggler border-0"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarContent"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarContent">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0 align-items-lg-center gap-lg-2">
            {/* Always Visible Public QR & Tracking links */}
            <li className="nav-item">
              <Link className="nav-link fw-semibold text-primary" to="/public-complaint">
                <i className="bi bi-qr-code-scan me-1"></i> {t('publicDesk')}
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link fw-medium" to="/track-complaint">
                <i className="bi bi-search me-1"></i> {t('trackTicket')}
              </Link>
            </li>

            {user ? (
              <>
                <li className="nav-item">
                  <Link
                    className="nav-link fw-medium"
                    to={user.role === 'customer' ? '/dashboard' : '/staff-dashboard'}
                  >
                    <i className="bi bi-speedometer2 me-1"></i> {t('dashboard')}
                  </Link>
                </li>
                {user.role === 'admin' && (
                  <>
                    <li className="nav-item">
                      <Link className="nav-link fw-medium" to="/admin/users">
                        <i className="bi bi-people me-1"></i> {t('staffUsers')}
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link fw-medium" to="/admin/departments">
                        <i className="bi bi-building me-1"></i> {t('departments')}
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link fw-medium" to="/admin/areas">
                        <i className="bi bi-geo-alt me-1"></i> {t('areaMaster')}
                      </Link>
                    </li>
                  </>
                )}
                <li className="nav-item d-flex align-items-center gap-2 bg-light px-3 py-1 rounded-pill">
                  <i className="bi bi-person-circle text-primary"></i>
                  <span className="fw-semibold small">{user.full_name}</span>
                  <span className="badge bg-primary text-capitalize small">{user.role?.replace('_', ' ')}</span>
                </li>
                <li className="nav-item">
                  <button
                    onClick={handleLogout}
                    className="btn btn-outline-danger btn-sm rounded-pill px-3"
                  >
                    <i className="bi bi-box-arrow-right me-1"></i> {t('logout')}
                  </button>
                </li>
              </>
            ) : (
              <>
                <li className="nav-item">
                  <Link className="nav-link fw-medium" to="/login">
                    {t('signIn')}
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="btn btn-primary-gradient px-4 py-2" to="/register">
                    {t('registerAccount')}
                  </Link>
                </li>
              </>
            )}

            {/* Language Switcher Pill Toggle */}
            <li className="nav-item ms-lg-2 my-2 my-lg-0">
              <div className="lang-switcher-pill" title="Switch Language / भाषा निवडा">
                <button
                  type="button"
                  className={`lang-btn ${language === 'en' ? 'active' : ''}`}
                  onClick={() => setLanguage('en')}
                >
                  <i className="bi bi-translate me-1"></i> English
                </button>
                <button
                  type="button"
                  className={`lang-btn ${language === 'mr' ? 'active' : ''}`}
                  onClick={() => setLanguage('mr')}
                >
                  मराठी
                </button>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
